<div id="pyramid-chartdiv" style="width: 100%; height: 500px"></div>
